import { VStack, StackProps } from '@chakra-ui/react';

const ProductManagerTile = (props: StackProps) => (
  <VStack
    sx={{
      py: 1.5,
      px: 5,
      bgColor: 'base2Colour.500',
    }}
    {...props}
  />
);

export default ProductManagerTile;
